<ng-container [ngSwitch]="disclamerConfig?.disclamerViewType">

  <ng-container *ngSwitchCase="'text'">
    <div class="dashboard-title" [ngClass]="showDisclaimerIcon ? 'dashboard-title-disclamer-shown' : ''">
      <div class="dashboard-title-disclaimer">
        <div class="dashboard-title-disclamer-content">{{ text }}</div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngSwitchDefault>
      <div class="dashboard-title icon-disclamer" *ngIf="showDisclaimerIcon">
          <i class="fa fa-exclamation-triangle" aria-hidden="true" genTooltip [tooltipPosition]="'BOTTOM'" [tooltipHtml]="text" [tooltipShow]="true"
            [appendToBody]="true" [updateMaxToolTipWidthRelatively]="true"></i>
        </div>

  </ng-container>

</ng-container>


